function xCookieBanner(delay) {
  return {
    show: false,
    init() {
      if (!localStorage.getItem('cookie_banner_accepted')) {
        setTimeout(() => {
          this.show = true;
        }, delay * 1000);
      }
    },
    handleAccept() {
      localStorage.setItem('cookie_banner_accepted', 'true');
      this.show = false;
    },
    handleDecline() {
      localStorage.setItem('cookie_banner_accepted', 'declined');
      this.show = false;
    }
  };
}

document.addEventListener('alpine:init', () => {
  Alpine.store('xShowCookieBanner', {
    show: true
  });
});
